import { ListItemText, ListItemIcon, MenuItem as MuiMenuItem } from '@mui/material';
import withStyles from '@mui/styles/withStyles';

const styles = /* istanbul ignore next */ ({ palette }) => ({
  root: {
    paddingTop: 0,
    paddingBottom: 0,
  },
  iconContainer: {
    color: 'inherit',
    minWidth: 'auto',
  },
  textContainer: {
    color: palette.text.onMain,
    flex: '0 1 auto',
    '& > span': {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  },
});

function MenuItem({
  classes = {},
  children = null,
  className = '',
  Component = 'div',
  icon: MenuIcon = null,
  isIconOnRight = false,
  label,
  subLabel = '',
  ariaLabel = 'Show menu',
  ...otherProps
}) {
  let iconElement;

  if (MenuIcon) {
    const MenuIconNode =
      typeof MenuIcon === 'function' ? <MenuIcon aria-label={ariaLabel} /> : MenuIcon;
    iconElement = <ListItemIcon className={classes.iconContainer}>{MenuIconNode}</ListItemIcon>;
  } else {
    iconElement = null;
  }

  return (
    <MuiMenuItem
      className={className}
      classes={{ root: classes.root }}
      component={Component}
      {...otherProps}
    >
      {!isIconOnRight && iconElement}
      <ListItemText
        className={classes.textContainer}
        inset={!isIconOnRight && !iconElement}
        primary={label}
        secondary={subLabel}
      />
      {isIconOnRight && iconElement}
      {children}
    </MuiMenuItem>
  );
}

export default withStyles(styles)(MenuItem);
